"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectDestructuringEmpty"));

var _react = _interopRequireDefault(require("react"));

var _Item = _interopRequireDefault(require("./../../Item"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function Column(_ref) {
  (0, _objectDestructuringEmpty2["default"])(_ref);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['wrapper']
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['headline']
  }, /*#__PURE__*/_react["default"].createElement(_Item["default"], {
    size: 'small'
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['line']
  }, /*#__PURE__*/_react["default"].createElement(_Item["default"], {
    size: 'small'
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['line']
  }, /*#__PURE__*/_react["default"].createElement(_Item["default"], {
    size: 'small'
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['line']
  }, /*#__PURE__*/_react["default"].createElement(_Item["default"], {
    size: 'small'
  })));
}

var _default = Column;
exports["default"] = _default;